
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/virtual-office-phone",
      function () {
        return require("private-next-pages/virtual-office-phone.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/virtual-office-phone"])
      });
    }
  